// HelloWorld.js
import React, { useState } from 'react';

const HelloWorld = ({ initialText = "Hello World 1" }) => {
  const [inputValue, setInputValue] = useState(initialText);

  return (
    <input
      type="text"
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      style={{
        background: 'transparent',
        border: 'none',  // Remove border
        padding: '5px 10px',
        fontSize: '24px',
        fontWeight: 'bold',
        textAlign: 'center',
        width: '300px',
        outline: 'none'  // Remove focus outline as well
      }}
    />
  );
};

export default HelloWorld;